export function getChangedIndex(firstWord = '', secondWord = '') {
  return [...firstWord].findIndex(
    (letter, index) => letter !== secondWord[index],
  );
}

function RowChain({
  wordLength,
  incomingIndex,
  outgoingIndex,
  hideIncomingSegment = false,
}) {
  const hasIncoming = Number.isInteger(incomingIndex);
  const hasOutgoing = Number.isInteger(outgoingIndex);

  if (!hasIncoming) {
    return null;
  }

  const columnCenter = (index) => `${((index + 0.5) / wordLength) * 100}%`;
  const firstIndex = Math.min(incomingIndex, outgoingIndex ?? incomingIndex);
  const columnSpan = hasOutgoing
    ? `${(Math.abs(outgoingIndex - incomingIndex) / wordLength) * 100}%`
    : '0%';

  return (
    <span className="word-row__step-chain" aria-hidden="true">
      {!hideIncomingSegment && (
        <span
          className={`word-row__chain-vertical word-row__chain-vertical--incoming ${
            hasOutgoing ? '' : 'word-row__chain-vertical--terminal'
          }`}
          style={{ left: columnCenter(incomingIndex) }}
        />
      )}
      {hasOutgoing && (
        <span
          className="word-row__chain-vertical word-row__chain-vertical--outgoing"
          style={{ left: columnCenter(outgoingIndex) }}
        />
      )}
      {hasOutgoing && incomingIndex !== outgoingIndex && (
        <>
          <span
            className="word-row__chain-horizontal"
            style={{
              left: columnCenter(firstIndex),
              width: columnSpan,
            }}
          />
          <span
            className="word-row__chain-junction"
            style={{ left: columnCenter(incomingIndex) }}
          />
          <span
            className="word-row__chain-junction"
            style={{ left: columnCenter(outgoingIndex) }}
          />
        </>
      )}
    </span>
  );
}

export default RowChain;
